import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data9_8_2_default } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import Compared from "../../../Compared";
import { Prompt } from 'react-router-dom';

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            note: {
                note: ""
            },
            loadingSave: false,
            print: false,
            isEdit: false
        }
    }


    componentDidMount() {
        this.getTable9_8(this.state.date);
        //在关闭页面时弹出确认提示窗口
        window.addEventListener('beforeunload', this.handleWindowClose);
    }

    handleWindowClose = (ev) => {
        const confirmationMessage = "9.8.2 数据还未保存,确定要离开吗?";
        (ev || window.event).returnValue = confirmationMessage;
        if (this.state.isEdit) {
            return confirmationMessage;
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleWindowClose);
    }

    computeNum = (data) => {
        // 计算总额
        data[15]['quantity'] = 0;
        data[15]['total_amount'] = 0;

        for (let i = 0; i < 15; i++) {
            data[15]['quantity'] += Number(data[i]['quantity']);
            data[15]['total_amount'] += Number(data[i]['total_amount']);
        }
        data[15]['quantity'] = data[15]['quantity'].toFixed(2);
        data[15]['total_amount'] = data[15]['total_amount'].toFixed(2);

        for (let i = 0; i < 16; i++) {
            data[i]['average_unit_price'] = Number(data[i]['quantity']) == 0 ? 0 : (Number(data[i]['total_amount']) / Number(data[i]['quantity'])).toFixed(2);
            data[i]['total_purchase_percent'] = Number(data[15]['total_amount']) == 0 ? 0 : (Number(data[i]['total_amount']) / Number(data[15]['total_amount']) * 100).toFixed(2);
        }
        data[17]['total_amount'] = (Number(data[16]['total_amount']) == 0 ? 0 : Number(data[15]['total_amount']) / Number(data[16]['total_amount']) * 100).toFixed(2);
        this.setState({
            data
        })
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
        this.setState({ isEdit: true });
    }

    // 查询表格9_8的内容
    getTable9_8 = (date) => {
        const dataBegin = JSON.stringify(data9_8_2_default);
        let data = JSON.parse(dataBegin);
        fetch(`/_9_8_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }



    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }

        fetch('/add_9_8_2', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false, isEdit: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable9_8(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_8_2', 1.5, '9.82', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Purchase Item 采购项目',
            dataIndex: 'purchase_item',
            key: 'purchase_item',
            align: "center",
            render: (text, record, index) => {
                if (index >= 0 && index <= 14) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    this.onChange('purchase_item', e.target.value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                            {text}
                        </div>
                    )
                }
            }
        }, {
            title: 'Unit 计量单位',
            dataIndex: 'unit',
            key: 'unit',
            align: "center",
            render: (text, record, index) => {
                if (index >= 0 && index <= 14) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    this.onChange('unit', e.target.value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`}>
                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }
            }
        }, {
            title: 'Kitchen 厨房',
            dataIndex: 'kitchen',
            key: 'kitchen',
            align: "center",
            render: (text, record, index) => {
                if (index >= 0 && index <= 14) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    this.onChange('kitchen', e.target.value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`}>
                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }
            }
        }, {
            align: "center",
            title: 'Current Month Actual - This Year 本年当月',
            children: [{
                title: <div>Quantity <br />采购量</div>,
                dataIndex: 'quantity',
                key: 'quantity',
                align: "center",
                render: (text, record, index) => {
                    const title = ['Current Month Actual - This Year 本年当月', 'Quantity 采购量'];
                    if (index >= 0 && index <= 14) {
                        return (
                            <Compared data={{ index, key: 'quantity', title, sqlName: "_9_8_2", name: record.purchase_item, type: 'number' }}>
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={2}
                                        className="table_numInput"
                                        defaultValue={text == 0 ? '' : text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(2));
                                            this.onChange('quantity', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'quantity', title, sqlName: "_9_8_2", name: record.purchase_item, type: 'number' }}>
                                <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`}>
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </Compared>
                        )
                    }

                }
            }, {
                title: <div>Average Unit Price<br />平均单价</div>,
                dataIndex: 'average_unit_price',
                key: 'average_unit_price',
                align: "center",
                render: (text, record, index) => {
                    const title = ['Current Month Actual - This Year 本年当月', 'Average Unit Price 平均单价'];
                    return (
                        <Compared data={{ index, key: 'average_unit_price', title, sqlName: "_9_8_2", name: record.purchase_item, type: 'number' }}>
                            <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`}>
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: <div>Total Amount<br />采购总金额</div>,
                dataIndex: 'total_amount',
                key: 'total_amount',
                align: "center",
                render: (text, record, index) => {
                    const title = ['Current Month Actual - This Year 本年当月', 'Total Amount 采购总金额'];
                    if ((index >= 0 && index <= 14) || index == 16) {
                        return (
                            <Compared data={{ index, key: 'total_amount', title, sqlName: "_9_8_2", name: record.purchase_item, type: 'number' }}>
                                <div className="table-padding table-color-number">
                                    <InputNumber
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        precision={2}
                                        className="table_numInput"
                                        defaultValue={text == 0 ? '' : text}
                                        onBlur={(e) => {
                                            let value = Number(e.target.value.replace(/,/g, '') || '0');
                                            value = Number(value.toFixed(2));
                                            this.onChange('total_amount', value, index)
                                        }}

                                    />
                                </div>
                            </Compared>
                        )
                    } else {
                        return (
                            <Compared data={{ index, key: 'total_amount', title, sqlName: "_9_8_2", name: record.purchase_item, type: 'number' }}>
                                <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`}>
                                    {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (index == 17 ? '%' : '')}
                                </div>
                            </Compared>
                        )
                    }
                }
            }, {
                title: '%of Total Purchase',
                dataIndex: 'total_purchase_percent',
                key: 'total_purchase_percent',
                align: "center",
                width: 140,
                render: (text, record, index) => {
                    const title = ['Current Month Actual - This Year 本年当月', '%of Total Purchase'];
                    return (
                        <Compared data={{ index, key: 'total_purchase_percent', title, sqlName: "_9_8_2", name: record.purchase_item, type: 'percent' }}>
                            <div className={`table-padding ${(index > 14 && index != 16) ? 'table-color-footer' : ''}`}>
                                {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (index > 15 ? '' : '%')}
                            </div>
                        </Compared>
                    )
                }
            }]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table9_8_2">
                        <Row>9.8.2 YTD 年累计</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                    });
                                    this.getTable9_8(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_8">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>
                    {
                        this.state.isEdit && <Prompt
                            message="9.8.2 数据还未保存,确定要离开吗?"
                        />
                    }
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-8/9-8-2/index.js